export default "__VITE_ASSET__BjLOLOwm__"